
import React from 'react';
import './ClubXian2.scss';
import ClubXianNotice from '../../../widgets/Xi/component/ClubXianNotice';
import 클럽자이안2 from '../../../shared/asset/Xi/클럽자이안2.jpg';

const ClubXian2 = () => {
  const notices = [
    'CLUB XIAN의 이미지는 실제와 차이가 있습니다.',
    'OCS(오픈커뮤스테이션), 작은도서관(교보문고)은 업체의 사정으로 인해 상품 변경 또는 서비스 제공의 중단될 수 있으며, 입주자대표회의 인수인계 시 서비스가 변경/수정/중단될 수 있습니다.',
    '입주민 부대복리시설인 OSC(오픈커뮤스테이션) 장비 설치 및 작은도서관(교보문고)의 큐레이션 서비스(2년)는 시공자에서 비용을 지급하여 운영 예정이며, 이후에는 입주자대표회의에서 운영할 수 있습니다. 현재 구축 운영을 위해서 물가변동에 관하여는 동력승수관리비 등은 입주민 관리비에서 부과시근 이용 허가하시길 바랍니다. 다만, 동력승수관리비 등의 부담은 입주자대표회의 구성 전까지는 일부안 전체의 관리비로 부담되나, 입주자대표회의 구성 이후에는 입주자 대표회의 결정에 따라 입주민 전체의 공동관리비로 부과시거나 사용자(수익자) 부담으로 부과 예정이오니 계약자께서는 계약 시 이를 충분히는 조건으로 계약 체결하셔야 합니다.',
    '작은도서관(교보문고)은 무인으로 운영되며, 큐레이션 서비스는 2년 동안 매월 약100만원 상당의 도서를 시공사에서 비용을 지급하여 운영될 예정입니다. 법도 약정된 기간 이후에는 서비스의 운영이 종료될 수 있음으로 이 점 양지하시기 바랍니다.',
    '해당 단지 커뮤니티센터는 각 단지별로 별도 운영되도록 계획되었으며, 타 단지 커뮤니티센터 사용이 제한될 수 있습니다. 단지별(1단지/2단지) 시설물의 운영 여부는 인조 주 (가칭)주민자치정회기구\'의 결정에 따라 변경될 수 있습니다.'
  ];

  return (
    <div className="club-xian2">
      <div className="main-content">
        <div className="image-section">
          <img src={클럽자이안2} alt="클럽자이안 2단지" />
        </div>
      </div>
      <ClubXianNotice notices={notices} />
    </div>
  );
};

export default ClubXian2;